<template>
  <div v-if="rowVisible" class="h-i" @click="openInfoBox">
    <div class="h-i-top">
      <div class="h-i-score" :class="thisCol">{{ itemData.sco }}</div>
      <div class="h-i-sname">
        {{ hasShortName ? itemData.sname : itemData.name }}
        <div v-if="hasShortName" class="h-i-name">{{ itemData.name }}</div>
      </div>
      
    </div>
    <!--<div class="h-i-bot">
      <span v-if="itemData.H !== undefined && itemData.H !== '?'">{{ itemData.H }}</span>
      <span v-if="itemData.A !== undefined && itemData.A !== '?'">{{ itemData.A }}</span>
      <span v-if="itemData.L !== undefined && itemData.L !== '?'">{{ itemData.L }}</span>
      <span v-if="itemData.B !== undefined && itemData.B !== '?'">{{ itemData.B }}</span>
      <span v-if="itemData.note !== undefined" class="h-i-bot-note">{{ noteMessage }}</span>
    </div>-->
  </div>
</template>

<script>
export default {
  data(){
    return {
      noteMessage: 'note',
      colClasses: { 0: 's0', 1: 's1', 2: 's2', 3: 's3', '?': 'de' }
    }
  },
  props: {
    itemData: {
      type: Object
    },
    searchTerm: {
      type: String
    }
  },
  computed: {
    itemName() {
      if ('sname' in this.itemData) {
        return this.itemData.sname
      } else {
        return this.itemData.name
      }
    },
    hasShortName() {
      return 'sname' in this.itemData
    },
    hasNote () {
      return 'note' in this.itemData
    },
    currentlySearching() {
      return !(this.searchTerm === '')
    },
    thisCol() {
      return this.colClasses[this.itemData.sco]
    },
    rowVisible() {
      if (this.currentlySearching) {
        return this.isInData(this.searchTerm.toLowerCase())
      } else {
        return true
      }
    }
  },
  methods: {
    openInfoBox() {
      this.$root.$emit('openModal', this)
    },
    isInData(str) {
      if (this.itemData.name.toLowerCase().includes(str)
      || (this.hasShortName && this.itemData.sname.toLowerCase().includes(str)) 
      || (this.hasNote && this.itemData.note.toLowerCase().includes(str))) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.h-i-score{
  @apply absolute border-4 rounded-full text-center font-bold text-lg;
  line-height: 28px;
  width: 2.3rem;
  height: 2.3rem;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 1.1rem;
}
.h-i-score.s0{
  @apply border-green-500 text-green-800;
}
.h-i-score.s1{
  @apply border-yellow-500 text-yellow-800;
}
.h-i-score.s2{
  @apply border-orange-500 text-orange-800;

}
.h-i-score.s3{
  @apply border-red-500 text-red-800;

}
.h-i-score.de{
  @apply border-gray-500 text-gray-800;

}

.h-i{
  @apply relative py-3 cursor-pointer text-lg border-b border-gray-300 flex content-center justify-center flex-col;
  min-height: 4.1rem;
}

.h-i:nth-child(odd){
  /* @apply bg-gray-100; */
}

.h-i-sname{
  @apply block text-gray-800 font-bold mr-4;
  margin-left: 4.6rem;
}

.h-i-name{
  @apply text-sm font-normal text-gray-600 leading-tight;
  margin-top: -1px;
  /* uppercase tracking-wide font-bold  */
}

.h-i-sname::first-letter, .h-i-name::first-letter, .first-letter-upper::first-letter{
  @apply uppercase;
}

.h-i-bot{
  @apply uppercase font-bold text-sm tracking-wide text-gray-500 ml-12;
}

.h-i-bot > span{
  @apply mr-2;
}

.h-i-bot-note{
  @apply float-right pr-2;
}
</style>
